module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAJ9JREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9LINBTj+D++oAbG8WhQjwb1aFDTJ6gptRjks4PkaBywOB61ePBaDMxG+sSI0cLHE4AWxSNZOh9IBdArqGF5twCIE+gVxwVIBYQAEF8AhQJdikxonB6Atq0cgIXIR7qlSpDlQMw/2lAf9AAgwABt4zGM1diF5gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/8.png
// module id = 763
// module chunks = 0